// ============================================================================
// TrimaRankingOnboarding — One-shot welcome overlay before question 1
// ============================================================================
// Shown only on the first question of the ranking phase, dismissed by clicking
// "J'ai compris". Not persisted: if the user quits during ranking and comes
// back later, they restart from invitation anyway, so they'll see it again.
// ============================================================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/button/Button';
import {
  TrimaOnboardingBackdrop,
  TrimaOnboardingCard,
} from 'pages/questionnaire-trima/slides/ranking/TrimaRankingOnboarding.styled';

export interface TrimaRankingOnboardingProps {
  totalQuestions: number;
  onDismiss: () => void;
}

const TrimaRankingOnboarding: React.FC<TrimaRankingOnboardingProps> = ({
  totalQuestions,
  onDismiss,
}) => {
  const { t } = useTranslation('trima');
  return (
    <TrimaOnboardingBackdrop role="dialog" aria-modal="true">
      <TrimaOnboardingCard>
        <div className="trima-onboarding-icon" aria-hidden="true">👋</div>
        <h2>{t('ranking.onboarding.title')}</h2>
        <p>{t('ranking.onboarding.intro')}</p>
        <p>{t('ranking.onboarding.rule')}</p>
        <p>{t('ranking.onboarding.count', { count: totalQuestions })}</p>
        <div className="trima-onboarding-cta">
          <Button fill="solid" color="accent" onClick={onDismiss}>
            <span>{t('ranking.onboarding.cta')}</span>
          </Button>
        </div>
      </TrimaOnboardingCard>
    </TrimaOnboardingBackdrop>
  );
};

export default TrimaRankingOnboarding;
